<article>
  <div class="tabview-list">
    <div [class.active]="tabIndex() === 0" (click)="tabClick(0)"><i class="mdi mdi-view-list"></i> Issues</div>
    @if (can.create) {
      <div [class.active]="tabIndex() === 1" (click)="tabClick(1)" title=""><i class="mdi mdi-plus"></i> Create</div>
    }
    <div [class.active]="tabIndex() === 9" (click)="tabClick(9)"><i class="mdi mdi-shield-account-outline"></i> Admin</div>
    <div></div>
  </div>
  <main>
    <router-outlet></router-outlet>
  </main>
</article>
